/* eslint-disable  no-undef */
/* eslint-disable no-underscore-dangle */
import React from 'react'
import { useDispatch } from 'react-redux'
// eslint-disable-next-line
import { AdvancedMarker as OverlayView } from '@vis.gl/react-google-maps/dist/index.umd.js'
import { handleFirebaseMarkerClicked } from '../../redux/myMapsSlice'
import IconPicker from '../../../../../apps/AppComponents/IconPicker/IconPicker'
import firebaseMarkerStyles from './firebaseMarkerStyles'

function FirebaseMarker(props) {
  const dispatch = useDispatch()
  const { stop, map } = props
  const classes = firebaseMarkerStyles()

  const updateHandleMarkerIsActive = (e, markerStop) => {
    handleFetchStopLogic(e, markerStop)
  }

  const handleFetchStopLogic = (e) => {
    e.stopPropagation()
    map.panTo({
      lat: parseFloat(stop.location._lat),
      lng: parseFloat(stop.location._long),
    })
    dispatch(handleFirebaseMarkerClicked(stop))
  }
  return (
    <button
      type="button"
      aria-label="Custom Marker"
      onClick={updateHandleMarkerIsActive}
    >
      <OverlayView
        key={stop.id}
        position={{
          lat: stop.location._lat,
          lng: stop.location._long,
        }}
        mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
        className={classes.firebaseMarkerIcon}
      >
        <IconPicker iconName={stop.icon} color={stop.color} size="2x" />
      </OverlayView>
    </button>
  )
}

export default FirebaseMarker
